// src/Actions/studentCourseTreeAction.js

import api from "lib/api/api";

export const FETCH_STUDENT_COURSE_TREE_REQUEST =
  "FETCH_STUDENT_COURSE_TREE_REQUEST";
export const FETCH_STUDENT_COURSE_TREE_SUCCESS =
  "FETCH_STUDENT_COURSE_TREE_SUCCESS";
export const FETCH_STUDENT_COURSE_TREE_FAILURE =
  "FETCH_STUDENT_COURSE_TREE_FAILURE";

export const fetchStudentCourseTree = () => async (dispatch) => {
  dispatch({ type: FETCH_STUDENT_COURSE_TREE_REQUEST });
  try {
    const response = await api.get(`/courses/course-tree`); // updated URL for students
    dispatch({
      type: FETCH_STUDENT_COURSE_TREE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_STUDENT_COURSE_TREE_FAILURE,
      payload: error.message,
    });
  }
};
